module.exports = __webpack_public_path__ + "img/744.9392d3f6.jpg";